import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtl from 'stylis-plugin-rtl';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const options = {
  rtl: { key: 'css-ur', stylisPlugins: [rtl] },
  ltr: { key: 'css-en' },
};

export function RtlProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const dir = i18n.dir();

  useEffect(() => {
    const htmlElement = document.documentElement;
    htmlElement.lang = i18n.language;
    htmlElement.dir = dir;
  }, [i18n.language, dir]);

  const cache = createCache(options[dir]);
  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
